<!-- 内容审核与上下线 -->
<template>
  <div>
    <bread-crumb></bread-crumb>

    <div class="search-bar">
      <div class="input-group">
        <el-input
          style="width: 32%"
          v-model="searchParams.reporterPin"
          placeholder="举报人pin"
          clearable
        />
        <el-input
          style="width: 32%"
          v-model="searchParams.reportedPin"
          placeholder="被举报人pin"
          clearable
        ></el-input>
        <el-input
          style="width: 32%"
          v-model="searchParams.sessionId"
          placeholder="会话SID"
          clearable
        ></el-input>

        <el-select
          style="width: 32%"
          v-model="searchParams.reportCategory"
          placeholder="举报类型"
          clearable
        >
          <el-option
            v-for="(item, index) in categoryMapperList"
            :label="item.label"
            :value="item.value"
            :key="item.value"
          />
        </el-select>
        <div class="button-group">
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </div>
      </div>
    </div>

    <div class="content-audit-tabel specil">
      <div class="piliangBox">
        <el-tabs @tab-click="handleTabsClick" v-model="tabName">
          <el-tab-pane label="全部" name="all"> </el-tab-pane>
          <el-tab-pane label="待处理" name="pending"> </el-tab-pane>
          <el-tab-pane label="已处罚" name="punish"> </el-tab-pane>
          <el-tab-pane label="不予处罚" name="forgive"> </el-tab-pane>
        </el-tabs>
        <el-button
          type="primary"
          @click="handleDoneMore"
          v-if="tabName === 'pending'"
          >批量处理</el-button
        >
      </div>

      <div class="base-table">
        <div class="base-table-table">
          <el-table
            ref="table"
            :data="tableData.tableList"
            style="width: 100%"
            stripe
            :cell-class-name="addClass"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              type="selection"
              align="center"
              width="65"
              fixed
              v-if="tabName === 'pending'"
            />
            <template v-for="(item, index) in tableData.tableHeader">
              <el-table-column
                :prop="item.prop"
                :label="item.label"
                :align="left"
                :key="index"
                :width="item.width ? item.width : null"
              >
                <template slot-scope="scope">
                  <div v-if="item.label == '会话SID'">
                    <p>{{ scope.row[item.prop] }}</p>
                  </div>
                  <div v-if="item.label == '举报人pin'">
                    <p>{{ scope.row[item.prop] }}</p>
                  </div>
                  <div v-if="item.label == '被举报人pin'">
                    <p>{{ scope.row[item.prop] }}</p>
                  </div>
                  <div v-if="item.label == '举报类型'">
                    <p>{{ scope.row[item.prop] | filterReportCategory }}</p>
                  </div>
                  <div v-if="item.label == '举报描述'">
                    <el-tooltip
                      effect="light"
                      :content="scope.row.description || scope.row[item.prop]"
                      placement="top-start"
                    >
                      <p class="overflow">
                        {{ scope.row.description || scope.row[item.prop] }}
                      </p>
                    </el-tooltip>
                  </div>
                  <div v-if="item.label == '举报图'">
                    <el-image
                      v-for="(picitem, picindex) in scope.row[item.prop]"
                      class="previewImg"
                      :src="picitem"
                      :key="picindex"
                      :preview-src-list="scope.row[item.prop]"
                    >
                    </el-image>
                  </div>
                  <div v-if="item.label == '举报时间'">
                    <p>{{ scope.row[item.prop] | timeTransform }}</p>
                  </div>
                </template>
              </el-table-column>
            </template>
            <template>
              <el-table-column label="操作" width="150">
                <template slot-scope="scope">
                  <div>
                    <el-button
                      v-if="scope.row.status === 1"
                      type="text"
                      size="small"
                      @click="handleDone(scope.row)"
                      >处理</el-button
                    >
                    <span v-else-if="scope.row.status === 2">已处罚</span>
                    <span v-else-if="scope.row.status === 3">不予处罚</span>
                  </div>
                </template>
              </el-table-column>
            </template>
          </el-table>
        </div>
      </div>
    </div>
    <pagination
      @sizePageChange="paginationChangeProduct"
      :paginationDatas="paginationDataProduct"
    />
    <el-dialog
      :visible.sync="diglogModel.dialogVisible"
      width="30%"
      :before-close="handleCloseDig"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <span>
        <el-select placeholder="请选择禁言天数" v-model="diglogModel.JinValue">
          <el-option
            v-for="item in diglogModel.JinOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseDig">关 闭</el-button>
        <el-button @click="handlePunish(1)">不予处罚</el-button>
        <el-button type="primary" @click="handlePunish(2)">确认处罚</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import tableDom from "./tableDom.vue";
import breadCrumb from "../../../../components/breadCrumb";
import pagination from "../../../../components/pagination";
import { submitPenaltyInfo, queryUserReports } from "../../../../api/complaint";
import { categorylist } from "./mock.js";
import { getBusinessId } from "../../../../utils/enum";

export default {
  name: "goTopManage",
  data() {
    return {
      tableData: {
        tableList: [],
        tableHeader: [
          {
            label: "会话SID",
            prop: "sessionId",
            width: "250px",
          },
          {
            label: "举报人pin",
            prop: "reporterPin",
            width: "250px",
          },
          {
            label: "被举报人pin",
            prop: "reportedPin",
          },
          {
            label: "举报类型",
            prop: "reportCategory",
            width: "150px",
          },
          {
            label: "举报描述",
            prop: "title",
            width: "150px",
          },
          {
            label: "举报图",
            prop: "reportPicList",
            width: "350px",
          },
          {
            label: "举报时间",
            prop: "createTime",
          },
        ],
      },
      paginationDataProduct: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      searchParams: {
        reporterPin: "",
        reportedPin: "",
        sessionId: "",
        status: 1,
        reportCategory: "",
      },
      tabName: "pending",
      selectedRows: [], // 选中list

      diglogModel: {
        dialogVisible: false,
        JinOptions: [
          {
            value: 7,
            label: "禁言7天",
          },
          {
            value: 14,
            label: "禁言14天",
          },
          {
            value: 30,
            label: "禁言30天",
          },
          {
            value: 90,
            label: "禁言90天",
          },
          {
            value: 180,
            label: "禁言180天",
          },
          {
            value: 365,
            label: "禁言365天",
          },
        ],
        JinValue: 7,
      },
      categoryMapperList: [],
    };
  },
  components: {
    breadCrumb,
    tableDom,
    pagination,
  },
  async created() {
    console.log("list", categorylist);
    this.categoryMapperList = categorylist?.map((item) => ({
      label: item.title,
      value: item.id,
    }));
    this.getArticleList();
  },
  mounted() {},
  methods: {
    handleTabsClick(tab, event) {
      console.log(tab.name, event);
      this.tabName = tab.name;
      if (tab.name === "all") {
        this.searchParams.status = "";
      } else if (tab.name === "pending") {
        this.searchParams.status = 1;
      } else if (tab.name === "punish") {
        this.searchParams.status = 2;
      } else if (tab.name === "forgive") {
        this.searchParams.status = 3;
      }

      this.getArticleList();
    },
    // 重置处理数据
    resetSelectRows() {
      this.$refs?.table?.clearSelection?.();
      this.selectedRows = [];
      this.diglogModel.JinValue = 7;
    },
    // 关闭弹窗
    handleCloseDig() {
      this.diglogModel.dialogVisible = false;
      this.resetSelectRows();
    },
    // 批量处理
    handleDoneMore() {
      if (this.selectedRows.length > 0) {
        this.diglogModel.dialogVisible = true;
        return;
      }
      this.$message({
        message: "请勾选要处理的数据",
        type: "warning",
      });
    },
    // 处理
    handleDone(val) {
      console.log(val, this);
      this.diglogModel.dialogVisible = true;
      this.selectedRows = [val];
    },
    // 表格多选
    handleSelectionChange(val) {
      console.log(val, this);
      this.selectedRows = val;
    },
    // 处罚
    async handlePunish(type) {
      console.log(
        type === 2 ? "处罚" : "免罚",
        this.selectedRows,
        this.diglogModel.JinValue
      );
      const penalizedPins = [];
      const reportIds = [];
      this.selectedRows.map((item) => {
        if (item.id) reportIds.push(item.id);
        if (item.reportedPin) penalizedPins.push(item.reportedPin);
      });
      await this.submitPenaltyInfoApi({
        penalizedPins,
        penaltyType: type,
        reportIds,
        durationDays: this.diglogModel.JinValue,
        createBy: sessionStorage.getItem("user_pin"),
        tenantId: parseInt(this.$route.query.tenantid),
        businessId: this.getBusinessId(parseInt(this.$route.query.tenantid)),
      });
    },

    paginationChangeProduct(val) {
      this.paginationDataProduct = val;
      this.getArticleList();
    },
    // 处理
    async submitPenaltyInfoApi(params) {
      try {
        const res = await submitPenaltyInfo(params);
        console.log("submitPenaltyInfoApi", res);
        if (res) {
          this.getArticleList();
          this.handleCloseDig();
          return;
        }
        this.$message({
          message: res.msg || "请求失败",
          type: "warning",
        });
      } catch (err) {
        console.log("submitPenaltyInfoApi", err);
        this.$message({
          message: "请求失败",
          type: "warning",
        });
      }
    },
    //获取文章列表
    getArticleList() {
      this.resetSelectRows();
      let params = {
        tenantId: parseInt(this.$route.query.tenantid),
        businessId: this.getBusinessId(parseInt(this.$route.query.tenantid)),
        pageNo: this.paginationDataProduct.currentPage,
        pageSize: this.paginationDataProduct.pageSize,
        reporterPin: this.searchParams.reporterPin,
        reportedPin: this.searchParams.reportedPin,
        sessionId: this.searchParams.sessionId,
        status: this.searchParams.status,
        reportCategory: this.searchParams.reportCategory,
      };
      queryUserReports(params).then((res) => {
        this.tableData.tableList.splice(0, this.tableData.tableList.length);
        res.data.map((item) => {
          this.tableData.tableList.push(item);
        });
        this.paginationDataProduct.total = res.totalCount;
        this.paginationDataProduct.currentPage = res.pageNo;
        this.paginationDataProduct.pageSize = res.pageSize;
        console.log(
          "???",
          res.data,
          this.tableData,
          this.tableData.tableList[1]
        );
      });
    },

    handleReset() {
      this.searchParams = {
        reporterPin: "",
        reportedPin: "",
        sessionId: "",
        status: 1,
        reportCategory: "",
      };
      this.tabName = "pending";
      this.paginationDataProduct.currentPage = 1;
      this.getArticleList();
    },
    handleSearch() {
      this.paginationDataProduct.currentPage = 1;
      this.getArticleList();
    },
    getBusinessId(key) {
      return getBusinessId(key);
    },
  },
  filters: {
    filterReportCategory(value) {
      const item = categorylist?.find((item) => item.id === value);
      return item?.title || "";
    },
  },
};
</script>

<style lang="scss" scoped>
.content-audit-tabel {
  position: relative;
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  background: white;
  margin-top: 14px;
  &.specil {
    :deep(.el-tabs) {
      padding-bottom: 0;
      margin-bottom: 0;
    }
    :deep(.el-tabs__content) {
      display: none;
    }
    :deep(.el-tabs__header) {
      margin-bottom: 0;
    }
  }
  .import-btn {
    position: absolute;
    right: 20px;
    top: 20px;
    z-index: 11;

    .redTag {
      color: red;
    }
  }
}

.slot-item {
  span {
    margin: 0px 2px 0px 2px;
  }
}

:deep(.el-textarea__inner) {
  min-height: 130px !important;
  resize: none;
}

:deep(.el-form-item) {
  margin-bottom: 22px;
}

:deep(.modal-body) {
  margin-top: 30px;
}

.reasonDom {
  padding: 0 30px;
  height: 100px;
  line-height: 20px;
  font-size: 14px;
  color: rgba(44, 52, 67, 1);
  /*overflow: hidden;*/
  overflow-y: auto;
  max-height: 150px;
}

.freezeDom {
  /*margin-top: 30px;*/
  .freezeInp {
    max-height: 130px;
    max-width: 276px;

    // overflow: hidden;
    .el-input__count {
      background: rgba(0, 0, 0, 0);
      bottom: -30px;
    }
  }

  .mar-top30 {
    margin-top: 30px;
  }
}

.importBtn {
  display: inline-flex;
  align-items: flex-start;
  justify-content: center;
  margin-left: 5px;
}

.exportBtn {
  margin-left: 5px;

  span {
    margin-top: 5px;
    display: block;
    color: #abaaaa;
  }
}

.dropDown {
  margin-left: 10px;
}

.header-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header {
  font-size: 20px;
  font-weight: bold;
}

.form-container {
  height: 80vh;
  /* 设置固定高度 */
  overflow-y: auto;
  /* 启用垂直滚动条 */
}

:deep(.el-form-item__label) {
  font-weight: bold;
  /* 加粗 */
  margin-right: 20px;
  /* 右边距 */
}

.image-flex {
  display: flex;
  flex-wrap: wrap;
  /* 自动换行 */
  gap: 10px;
  /* 图片间距 */
}

.image-item {
  position: relative;
  width: calc(33.33% - 10px);
  /* 每行3个，减去间距 */
  height: 100px;
  /* 设置图片容器高度 */
  overflow: hidden;
  margin-bottom: 10px;
  /* 图片之间的垂直间距 */
}

.image-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  /* 图片覆盖容器 */
  cursor: pointer;
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: opacity 0.3s;
}

.image-item:hover .image-overlay {
  opacity: 1;
}

.image-overlay .el-button {
  margin: 0 5px;
}

.search-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
}

.input-group {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
}

.button-group {
  display: flex;
  gap: 10px;
}

.multiSelect {
  display: flex;
  align-items: center;
  // justify-content: center;
  font-size: 16px;
  margin-bottom: 10px;
}

.select-blue {
  margin-right: 5px;
  // color: blue;
}

.select-white {
  margin-right: 5px;
  color: rgb(0, 0, 0);
}

.drawer-footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 10px;
  border-top: 1px solid #ebeef5;
  background-color: #fff;
  /* 确保背景色 */
}

.drawer-footer .el-button {
  margin-left: 10px;
}
.piliangBox {
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  align-items: center;
}
.previewImg {
  width: 60px;
  height: 60px;
  margin: 2px;
  :deep(.el-image__inner) {
    object-fit: contain;
  }
}
.overflow {
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-align: center;
}
</style>
